import { ErrorMessage, Field, Label } from '../fieldset'
import { Input } from '../input'

export default function InputWithError({ error, type, name, label, required, onChange, value }) {
  return (
    <Field>
      <Label>{label}</Label>
      <Input type={type} name={name} invalid={error && error.length > 1 } required={required} value={value} onChange={(e) => onChange(e)}/>
      {error && error.length > 1 && <ErrorMessage>{error}</ErrorMessage>}
    </Field>
  )
}